import Reveal from "@/components/base/Reveal";
import { externalLinks, images } from "@/mocks/site";

const pillars = [
  "Local food economies that actually hold",
  "Community built around a shared table",
  "Creators, makers and food businesses",
  "Experiences that travel and stay",
];

export default function LocavoreSection() {
  return (
    <section className="relative overflow-hidden bg-secondary-100">
      <div className="w-full px-5 md:px-10 lg:px-16 py-20 md:py-28">
        <Reveal>
          <p className="eyebrow text-secondary-700">
            Section 02 — Locavore PODS
          </p>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-6">
            <Reveal>
              <h2 className="font-heading text-4xl leading-[1.02] text-foreground-950 sm:text-5xl md:text-6xl">
                THE MOVEMENT
              </h2>
            </Reveal>
            <Reveal delay={120}>
              <p className="mt-6 max-w-xl font-body text-lg leading-relaxed text-foreground-700">
                Locavore PODS is the wider ecosystem around the food — a
                community of growers, cooks, creators and food businesses
                building healthier local food economies, one pod at a time.
              </p>
            </Reveal>
            <Reveal delay={200}>
              <p className="mt-4 max-w-xl font-body text-base leading-relaxed text-foreground-700">
                It is the movement behind the plate: the farmers, the markets,
                the kitchens and the people who decide that where their food
                comes from matters.
              </p>
            </Reveal>

            <div className="mt-9 grid grid-cols-1 gap-x-8 gap-y-4 sm:grid-cols-2">
              {pillars.map((p, i) => (
                <Reveal key={p} delay={260 + i * 80}>
                  <div className="flex items-start gap-3">
                    <span className="mt-2 block h-1.5 w-1.5 shrink-0 rounded-full bg-secondary-500" />
                    <p className="font-body text-sm leading-relaxed text-foreground-700">
                      {p}
                    </p>
                  </div>
                </Reveal>
              ))}
            </div>

            <Reveal delay={600}>
              <div className="mt-11 flex flex-col gap-4 sm:flex-row sm:items-center">
                <a
                  href={externalLinks.locavorePods}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-3 whitespace-nowrap rounded-md bg-secondary-600 px-8 py-4 font-label text-[11px] uppercase tracking-label text-background-50 transition-colors duration-500 hover:bg-secondary-700"
                >
                  Explore Locavore PODS
                  <i className="ri-arrow-right-up-line text-base" />
                </a>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-6">
            <div className="grid grid-cols-2 gap-4">
              <Reveal variant="mask" className="col-span-2">
                <div className="aspect-[16/10] w-full overflow-hidden bg-foreground-900 image-zoom">
                  <img
                    src={images.kitchenCrew}
                    alt="Chefs and crew together in the kitchen"
                    title="The Locavore community"
                    className="h-full w-full object-cover object-center"
                  />
                </div>
              </Reveal>
              <Reveal variant="mask" delay={120}>
                <div className="aspect-[3/4] w-full overflow-hidden bg-foreground-900 image-zoom">
                  <img
                    src={images.locavoreMarket}
                    alt="A market table full of fresh local produce"
                    title="Locavore market"
                    className="h-full w-full object-cover"
                  />
                </div>
              </Reveal>
              <Reveal variant="mask" delay={200}>
                <div className="flex h-full flex-col gap-4">
                  <div className="aspect-[4/3] w-full overflow-hidden bg-foreground-900 image-zoom">
                    <img
                      src={images.locavoreFarm}
                      alt="A local farm at dawn"
                      title="Locavore farm"
                      className="h-full w-full object-cover"
                    />
                  </div>
                  <div className="flex flex-1 items-center gap-4 rounded-sm bg-background-50 px-5 py-4">
                    <div className="h-12 w-12 shrink-0 overflow-hidden rounded-full bg-background-200">
                      <img
                        src={images.locavoreMark}
                        alt="Locavore PODS"
                        className="h-full w-full object-cover"
                      />
                    </div>
                    <p className="font-heading text-sm italic leading-snug text-foreground-700">
                      "Be the Change."
                    </p>
                  </div>
                </div>
              </Reveal>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}